/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconSortAsc/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconSortAsc({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconSortAsc",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 14,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconSortAsc.Svg"
  data-view-path={viewPath}
 viewBox="0 0 14 14"
 style={{'--as-1-2kMcl9': alignSelf,'--mt-2-2kMcl9': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-2kMcl9': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-2kMcl9': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-2kMcl9': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-2kMcl9': opacity,'--w-10-2kMcl9': typeof width === 'number' ? `${width}px` : width,'--h-11-2kMcl9': typeof height === 'number' ? `${height}px` : height,'--f-12-2kMcl9': fill,'--a-7-2kMcl9': isAnimated ? animation : "none",'--sd-8-2kMcl9': isAnimated ? strokeDashoffset : 0,'--sd-9-2kMcl9': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconSortAsc.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M8.75 14a.75.75 0 000-1.5h-2a.75.75 0 000 1.5h2zm2-3a.75.75 0 000-1.5h-4a.75.75 0 000 1.5h4zM14 7.25a.75.75 0 01-.75.75h-6.5a.75.75 0 010-1.5h6.5a.75.75 0 01.75.75zM3.25 14a1 1 0 01-1-1V4H.75a.75.75 0 01-.53-1.28l2.5-2.5a.75.75 0 011.06 0l2.5 2.5A.75.75 0 015.75 4h-1.5v9a1 1 0 01-1 1z"
 style={{'--f-12-2kMcl9': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}